"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergySettingsModal = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var index_1 = require("../index");
var UsageControls_styled_1 = require("./UsageControls.styled");
var EnergySettingsModal = function (_a) {
    var _b;
    var defaultValues = _a.defaultValues, fuelOptions = _a.fuelOptions, unitOptions = _a.unitOptions, compareOptions = _a.compareOptions, onClose = _a.onClose, isOpen = _a.isOpen, setFuel = _a.setFuel, setUnit = _a.setUnit;
    var _c = __read((0, react_1.useState)(defaultValues), 2), values = _c[0], updateValue = _c[1];
    var _d = (0, core_1.useComponents)(), PrimaryCTAButton = _d.PrimaryCTAButton, Modal = _d.Modal, Stack = _d.Stack, SelectField = _d.SelectField;
    var _e = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _e.copy, Copy = _e.Copy;
    (0, react_1.useEffect)(function () {
        updateValue(defaultValues);
    }, [defaultValues]);
    var updateFuel = function (fuel) {
        updateValue(__assign(__assign({}, values), { fuel: fuel }));
        setFuel(fuel);
    };
    var updateUnit = function (unit) {
        updateValue(__assign(__assign({}, values), { unit: unit }));
        setUnit(unit);
    };
    return (react_1.default.createElement(Modal, { "data-testid": "energy-settings-modal", isOpen: isOpen, onClose: function () { return onClose(defaultValues); }, title: copy('modalTitle') },
        react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
            fuelOptions.length ? (react_1.default.createElement(index_1.ToggleField, { id: "fuel", label: copy('fuelLabel'), value: values.fuel, options: fuelOptions, onSelect: function (fuel) { return updateFuel(fuel); } })) : null,
            unitOptions.length ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(index_1.ToggleField, { id: "unit", label: copy('unitLabel'), value: values.unit, options: unitOptions, onSelect: function (unit) { return updateUnit(unit); } }),
                values.unit === 'pounds' ? (react_1.default.createElement(Copy, { copyKey: "controlsChargeDisclaimer" })) : null)) : null,
            compareOptions.length ? (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.USAGE_COMPARISON_SELECT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
                react_1.default.createElement(UsageControls_styled_1.StyledNoZoomSelect, { as: SelectField, id: "compare", "data-testid": "usage-compare", label: copy('compareLabel'), options: compareOptions, value: values.compare, fullWidth: "always", onValueChange: function (compare) {
                        return compare &&
                            updateValue(__assign(__assign({}, values), { compare: compare }));
                    } }))) : null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(PrimaryCTAButton, { fullWidth: "always", onClick: function () { return onClose(values); }, "data-testid": "modal-submit-button" },
                    react_1.default.createElement(Copy, { copyKey: "modalSubmit" }))))));
};
exports.EnergySettingsModal = EnergySettingsModal;
